function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { useContext } from "react";
import { useTheme } from "../../ThemeProvider";
import { useFormContext } from "../FormContext/FormContext";
import ThemeContext from "../../ThemeProvider/ThemeContext";
export function ReadOnlyText(_param) {
    var readOnlyRenderer = _param.readOnlyRenderer, children = _param.children, propDrop = _objectWithoutProperties(_param, [
        "readOnlyRenderer",
        "children"
    ]);
    var font = useContext(ThemeContext).font;
    var isRtl = useFormContext().isRtl;
    var spacing = useTheme().spacing;
    var readingDirection = isRtl ? 'rtl' : 'ltr';
    return _jsx("div", _objectSpread({}, propDrop, {
        css: {
            width: '100%',
            paddingTop: spacing[2],
            paddingBottom: spacing[1],
            color: font.color.base,
            fontSize: font.base.size.m,
            fontFamily: font.base.family,
            lineHeight: font.lineHeight.base,
            wordWrap: 'break-word',
            direction: readingDirection,
            whiteSpace: 'pre-wrap'
        },
        children: _jsx(_Fragment, {
            children: typeof readOnlyRenderer === 'function' ? readOnlyRenderer(children) : children === undefined || children === null || typeof children === 'string' && children === '' ? _jsx("span", {
                css: {
                    color: font.color.disabled,
                    userSelect: 'none'
                },
                "aria-hidden": true,
                children: '\u2014'
            }) : children
        })
    }));
}
